import React from 'react';
import Translate from 'translate';

const Statboxes = ( { data = {}, chatActive, phoneActive, title } ) => (
  <div className="row">
    <div className="col-xl col-sm-6">
      <div className="box box-default">
        <h5 className="m-0 font-weight-normal panel-title"><Translate id={title} /></h5>
        <div className="box-top">
          <span>{data['FACEBOOK'] || 0}</span>
        </div>
        <div className="box-info">
          <span>Facebook</span>
        </div>
        <div className="box-bottom">
          <i className="fa fa-facebook-square color-facebook"/>
        </div>
      </div>
    </div>
    <div className="col-xl col-sm-6">
      <div className="box box-default">
        <div className="box-top">
          <span><span>{data['TWITTER'] || 0}</span></span>
        </div>
        <div className="box-info">
          <span>Twitter</span>
        </div>
        <div className="box-bottom">
          <i className="fa fa-twitter-square color-twitter"/>
        </div>
      </div>
    </div>
    <div className="col-xl col-sm-6">
      <div className="box box-default">
        <div className="box-top">
          <span><span>{data['EMAIL'] || 0}</span></span>
        </div>
        <div className="box-info">
          <Translate id="email"/>
        </div>
        <div className="box-bottom">
          <i className="fa fa-envelope color-warning" style={{ fontSize: '35px' }}/>
        </div>
      </div>
    </div>
    {!!phoneActive &&
    <div className="col-xl col-sm-6">
      <div className="box box-default">
        <div className="box-top">
          <span><span>{data['PHONE'] || 0}</span></span>
        </div>
        <div className="box-info">
          <Translate id="phone"/>
        </div>
        <div className="box-bottom">
          <i className="fa fa-mobile color-danger"/>
        </div>
      </div>
    </div>
    }
    {!!chatActive &&
    <div className="col-xl col-sm-6">
      <div className="box box-default">
        <div className="box-top">
          <span><span>{data['CHAT'] || 0}</span></span>
        </div>
        <div className="box-info">
          <Translate id="chat"/>
        </div>
        <div className="box-bottom">
          <i className="fa fa-comments color-info-light"/>
        </div>
      </div>
    </div>
    }
    <div className="col-xl col-sm-6">
      <div className="box box-default">
        <div className="box-top">
          <span><span>{data['WALK_IN'] || 0}</span></span>
        </div>
        <div className="box-info">
          <span>Walk In</span>
        </div>
        <div className="box-bottom">
          <i className="fa fa-user"/>
        </div>
      </div>
    </div>
  </div>
);

module.exports = Statboxes;



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/StatBoxes.js